import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import OutlinedInput from "@mui/material/OutlinedInput";
import Typography from "@mui/material/Typography";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

import { useEffect } from "react";
import useInputObject from "../../hooks/useInputObject";
import { Button } from "@mui/material";

const infoTableCellSx = {
  fontSize: 18,
};

// 新規商品登録ページ
export default function VarInfo(props) {
  const { varInfo, isUpdateMode = false } = props;

  return (
    <TableContainer component={Box}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell width={180} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  変数区分&nbsp;
                </Grid>
                <Grid item xs="auto">
                  <Typography color="error">(必須)</Typography>
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <OutlinedInput
                onChange={(e) => varInfo.update("varDiv", e.target.value)}
                value={varInfo.Value.varDiv}
                sx={{ width: 400 }}
                disabled
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell width={180} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  変数コード&nbsp;
                </Grid>
                <Grid item xs="auto">
                  <Typography color="error">(必須)</Typography>
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <OutlinedInput
                onChange={(e) => varInfo.update("varCd", e.target.value)}
                value={varInfo.Value.varCd}
                sx={{ width: 400 }}
                disabled={isUpdateMode}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell width={180} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  変数値1&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <OutlinedInput
                onChange={(e) => varInfo.update("varValue1", e.target.value)}
                value={varInfo.Value.varValue1}
                sx={{ width: 400 }}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell width={180} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  変数値2&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <OutlinedInput
                onChange={(e) => varInfo.update("varValue2", e.target.value)}
                value={varInfo.Value.varValue2}
                sx={{ width: 400 }}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell width={180} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  変数値3&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <OutlinedInput
                onChange={(e) => varInfo.update("varValue3", e.target.value)}
                value={varInfo.Value.varValue3}
                sx={{ width: 400 }}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell width={180} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  変数値4&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <OutlinedInput
                onChange={(e) => varInfo.update("varValue4", e.target.value)}
                value={varInfo.Value.varValue4}
                sx={{ width: 400 }}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell width={180} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  並順&nbsp;
                </Grid>
                <Grid item xs="auto">
                  <Typography color="error">(必須)</Typography>
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <OutlinedInput
                onChange={(e) => varInfo.update("displayOrder", e.target.value)}
                value={varInfo.Value.displayOrder}
                sx={{ width: 400 }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
